// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function DashboardCardComponents__Tw$StyledContentBox(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-col bg-white p-5 h-full rounded-sm"
  });
}

let StyledContentBox = {
  make: DashboardCardComponents__Tw$StyledContentBox
};

function DashboardCardComponents__Tw$LoadingStateContainer(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-col justify-center items-center flex-grow text-lg leading-6 min-h-[230px] self-center w-full"
  });
}

let LoadingStateContainer = {
  make: DashboardCardComponents__Tw$LoadingStateContainer
};

function DashboardCardComponents__Tw$EmptyStateContainer(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "flex flex-col  items-center flex-grow text-gray-600 text-lg leading-6 max-w-[320px] self-center py-10 min-h-[230px] w-full h-full"
  });
}

let EmptyStateContainer = {
  make: DashboardCardComponents__Tw$EmptyStateContainer
};

function DashboardCardComponents__Tw$Header(props) {
  return JsxRuntime.jsx("h3", {
    children: props.text,
    className: "text-3xl font-medium text-gray-700 mb-6"
  });
}

let Header = {
  make: DashboardCardComponents__Tw$Header
};

function DashboardCardComponents__Tw$Footer(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
      href: props.href,
      children: props.linkText
    }),
    className: "flex flex-grow flex-col items-center justify-end "
  });
}

let Footer = {
  make: DashboardCardComponents__Tw$Footer
};

function DashboardCardComponents__Tw$StatsDisplayer(props) {
  let href = props.href;
  let content = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: props.value,
        className: "text-6xl font-black text-gray-700"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.label,
            className: ""
          }),
          JsxRuntime.jsx("div", {
            children: props.subLabel,
            className: ""
          })
        ],
        className: "mt-4 uppercase text-sm text-gray-500"
      })
    ]
  });
  return JsxRuntime.jsx("div", {
    children: href !== undefined ? JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: href,
        className: "text-gray-700 hover:text-gray-700",
        children: content
      }) : content,
    className: "bg-gray-50 hover:bg-gray-100 p-3 rounded-md w-full h-full text-center md:text-left"
  });
}

let StatsDisplayer = {
  make: DashboardCardComponents__Tw$StatsDisplayer
};

exports.StyledContentBox = StyledContentBox;
exports.LoadingStateContainer = LoadingStateContainer;
exports.EmptyStateContainer = EmptyStateContainer;
exports.Header = Header;
exports.Footer = Footer;
exports.StatsDisplayer = StatsDisplayer;
/* ButtonsV5 Not a pure module */
